import { Component, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA , MatDialogRef} from '@angular/material/dialog';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ArmazemService } from 'app/service/endereco/armazem.service';
import { ModuloService } from 'app/service/endereco/modulo.service';

@Component({
  selector: 'app-alocar-recipiente-dialog',
  templateUrl: './alocar-recipiente-dialog.component.html',
  styleUrls: ['./alocar-recipiente-dialog.component.scss']
})
export class AlocarRecipienteDialogComponent implements OnInit {
  caixa;
  posicao = false;
  vao = false;
  prateleira = false;
  modulos = [];
  selectedModulo;
  componentesFilho = [] ;
  selects = [];
  opcoesGerais = [];
  selectDisabled = [] ;
  contadorDisabled = 0;
  compSelected ;
  posicaoNum ;
  resultAlocacao;
  posicoesComponente = [];
  posicoeslivres = [];
  alocacoes;
  solicitacao;
  caixasDisponiveis;
  caixasAlocadasResult;
  caixasPendenteRealocacaoResult;
  allCaixas;
  novasAlocacoes = [];
  armazens : any[];
  resultArmazens ;
  alocacoesResult: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
 verticalPosition: MatSnackBarVerticalPosition = 'top';
 realocacao = false;
 eneableSelectArmazem = true;
  enebleSelectModulo = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private service : SolicitacaoService,
  private moduloService: ModuloService,
  private armazemService: ArmazemService,
  public dialogRef: MatDialogRef <AlocarRecipienteDialogComponent>, private _snackBar: MatSnackBar, ) {
    this.solicitacao = data.solicitacao;
    this.allCaixas = data.solicitacao.caixas.slice();
    if(this.solicitacao.tipoDaSolicitacao == "REALOCACAO_INTERNA"){
      this.realocacao = true;
    }

   if(this.realocacao){

    this.service.listarCaixasPendenteRealocacao(this.solicitacao.id).subscribe(data=>{
        this.caixasPendenteRealocacaoResult = data;
        if(this.caixasPendenteRealocacaoResult.cod == 200){
          this.caixasDisponiveis =  this.caixasPendenteRealocacaoResult.result;
        }else{
          this.openSnackBarError(this.caixasPendenteRealocacaoResult.message)
        }
    })

   }else{
    this.service.caixasAlocadasSolicitacao(this.solicitacao.id).subscribe(data=>{
      this.caixasAlocadasResult = data;
        if(this.caixasAlocadasResult.length == 0){
          this.caixasDisponiveis = this.allCaixas;
        }else{
          this.montarCaixasDisponiveis();
        }
    })
   }

  }

  montarCaixasDisponiveis(){

    this.allCaixas.forEach(element => {
      if(!this.existAlocacao(element.rgCaixa)){
        this.caixasDisponiveis.push(element)
      }
    });

  }

  existAlocacao(rgCaixa){
    let exist = false;
    this.caixasAlocadasResult.forEach(element => {
       if(element.rgRecipiente == rgCaixa){
         exist = true;
       }
    });

    return exist;
  }

  ngOnInit() {
    /*
    this.service.listarModulos().subscribe(data=>{
      this.modulos = data;
    })*/
    console.log(this.solicitacao.id);

    this.armazemService.listarArmazensUsuario().subscribe(data=>{
      this.resultArmazens = data;
      this.armazens =  this.resultArmazens ;
    })
  }

  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  onChangeArmazem(valor) {
    console.log(valor)
    if(valor != "Selecione um armazem..."){
      this.moduloService.getModuloByArmazem(valor).subscribe(data=>{
         this.modulos = data;
         if(this.modulos.length == 0){
            this.openSnackBarError("Nenhum módulo encontrado para este armazem ! ")
         }else{
           this.eneableSelectArmazem = false;
           this.enebleSelectModulo = true;
         }
      })
    }
  }

  onChangeModulo(value){
      if(value != "0"){
        this.limparFormulário();
        let moduloSelec = this.returnModulo(value);
        this.service.listarComponentesModulo(moduloSelec.id).subscribe(data=>{
          this.componentesFilho = data;
          if(this.componentesFilho.length > 0){
            console.log(this.componentesFilho)
              let opcoes = [];
              this.componentesFilho.forEach(element => {
                opcoes.push(element);
              });
              let componente = "0";
              let item = {"modulo":moduloSelec.id, "tipo": this.componentesFilho[0].tipoComponente.nome, "name" : componente+moduloSelec.id, "componente" : componente};
              let itemOpcoes = {"opcoes":opcoes, "modulo": moduloSelec.id, "name" : componente+moduloSelec.id ,  "componente" : componente};
              this.selects.push(item)
              this.opcoesGerais.push(itemOpcoes)
          }
          console.log( this.selects)

        }, error=>{
          console.log(error)

        })
      }else{
       this.limparFormulário();
      }
  }

  limparFormulário(){
    this.componentesFilho = [];
    this.selects = [];
    this.opcoesGerais = [];
    this.selectDisabled = [] ;
    this.contadorDisabled = 0;
    this.posicao = false;
    this.resultAlocacao = null;
    this.posicoesComponente = [];
    this.posicoeslivres = [];
    this.alocacoes = null;
  }

  onChangeComponente(value){
    let comp = this.returnComponente(value);
    console.log(comp)
    if(comp != null){
      this.compSelected = comp;
     // let disabled = {"select":this.contadorDisabled, "disable" : true}
      this.selectDisabled.push(this.contadorDisabled)
      this.contadorDisabled ++;


      if(comp.componentesFilhos.length > 0){
        this.componentesFilho=  comp.componentesFilhos;
        let opcoes = [];
        comp.componentesFilhos.forEach(element => {
          opcoes.push(element)
        });

        let modulo = "0";
        let item = {"modulo":modulo, "tipo": this.componentesFilho[0].tipoComponente.nome, "name" : modulo+comp.id, "componente" : comp.id};
        let itemOpcoes = {"opcoes":opcoes, "modulo": modulo, "name" :  modulo+comp.id ,  "componente" : comp.id};
        this.selects.push(item)
        this.opcoesGerais.push(itemOpcoes)
      }else if(comp.isAlocacaoRecipiente){
        this.posicoesComponente = [];
        this.posicao = true;
        this.service.alocacoesComponente(comp.id).subscribe(data=>{
          this.alocacoes = data;
          this.montarListaPosicoes(comp);
        })

      }

    }
  }

  montarListaPosicoes(comp){
    if(comp.qtdComponenteAlocavel != null){
      let qtdPosicoes = (comp.qtdComponenteAlocavel.qtdHorizontal *  comp.qtdComponenteAlocavel.qtdVertical) * comp.qtdComponenteAlocavel.qtdProfundidade;

      for(let i = 1; i <= qtdPosicoes; i ++){
          let result = this.isPosicaoAlocada(i) ;
          if(result != ""){
            this.posicoesComponente.push("Posição "+i+": " +result);
          }else{
            this.posicoeslivres.push(i)
            this.posicoesComponente.push("Posição "+i+": " +"LIVRE");
          }
      }
    }
  }

  isPosicaoAlocada(posi){
    let exist = "";
    this.alocacoes.forEach(element => {
        if(element.posicao == posi){
          exist = element.rgRecipiente;
        }
    });

    return exist;
  }



  salvar(){

    if(this.compSelected.isAlocacaoRecipiente && this.novasAlocacoes.length > 0){
        let user = localStorage.getItem('APS_USERNAME');
        let body = {"componenteId":this.compSelected.id, "alocacoes" : this.novasAlocacoes, "username" : user}

        this.service.salvarMultiplasAlocacoes(body).subscribe(data=>{
            if (data.cod != 200) {
              this.openSnackBarError(data.message);
            } else {
              this.alocacoesResult = data.result;
              if(this.alocacoesResult.length > 0){
                this.openSnackBarSuccess("Total de "+this.alocacoesResult.length+" recipientes alocados !");
                this.dialogRef.close();
              }
            }

        })

    }




    /*
    this.resultAlocacao = null;
    console.log(this.compSelected)
    console.log(this.posicaoNum)
   let user = localStorage.getItem('APS_USERNAME');
   console.log(user)
   console.log(typeof this.posicaoNum != "undefined")

   if(typeof this.posicaoNum != "undefined" && typeof this.compSelected != "undefined"){
      let body = {"componenteId" : this.compSelected.id, "username" : user, "posicao": this.posicaoNum, "caixaId" : this.caixa.id};
      this.service.alocarCaixa(body).subscribe(data=>{
        this.resultAlocacao = data;
        if(this.resultAlocacao.cod == 200){
            alert("Alocação concluída com sucesso");
            this.dialogRef.close();

        }else{
           alert(this.resultAlocacao.message);
        }
      })
   }*/
  }


  salvarRealocacaoM(){
    if(this.compSelected.isAlocacaoRecipiente && this.novasAlocacoes.length > 0){
      let user = localStorage.getItem('APS_USERNAME');
      let body = {"componenteId":this.compSelected.id, "solicitacaoId": this.solicitacao.id, "alocacoes" : this.novasAlocacoes, "username" : user}

      this.service.realocarMultiplascaixas(body).subscribe(data=>{

          this.alocacoesResult = data;
          if( this.alocacoesResult.cod ==200){
            if(this.alocacoesResult.result.length > 0){
              this.openSnackBarSuccess("Total de "+this.alocacoesResult.result.length+" recipientes realocados !");
              this.dialogRef.close();
            }
          }else{
            this.openSnackBarError(this.alocacoesResult.message)
          }
      })

    }
  }

  returnDibled(id){
    let disable = false;


    this.selectDisabled.forEach(element => {
        if(element == id){
          disable = true;
        }
    });

    return disable;
  }

  onChangePrateleira(value){
    this.posicao = true;
  }



  returnOpcoes(id, idComponentePai){
   // console.log("id componente pai" + idComponentePai)
    let opcoes = [];
    if(idComponentePai == "0"){
      this.opcoesGerais.forEach(element => {
        if(element.modulo == id){
          opcoes = element.opcoes;
        }
      });
    }else if(id == 0){
      this.opcoesGerais.forEach(element => {
        if(element.componente == idComponentePai){
          opcoes = element.opcoes;
        }
      });
    }

    return opcoes;
  }

  returnModulo(id){
    let moduloSelec = null;
    this.modulos.forEach(element => {
        if(element.id == id){
          moduloSelec = element;
        }
    });
    return moduloSelec;
  }

  returnComponente(id){
    let compoSelec = null;
    this.componentesFilho.forEach(element => {
      if(element.id == id){
        compoSelec = element;
      }
    });

    return compoSelec;
  }


  incluirCaixaPosicao(caixa){
    console.log(caixa)
    if(typeof this.posicoeslivres[0] != "undefined"){
      let posi = this.posicoeslivres[0]
      this.posicoesComponente[posi - 1] = "Posição "+posi+": " +caixa.rgCaixa;
      this.posicoeslivres.splice(0, 1);
      let posicaoCaixa = this.caixasDisponiveis.indexOf(caixa)
      this.caixasDisponiveis.splice(posicaoCaixa, 1)
      let newAlc = {"posicao": posi, "rgRecipiente": caixa.rgCaixa}
      console.log(newAlc)
      this.novasAlocacoes.push(newAlc);
    }else{
      alert("Prateleira sem posições o suficiente");
    }



  }

  onRightClick(e) {
    console.log(e);
  }

  alocarTodos(){
    let incluidos = [];
    this.caixasDisponiveis.forEach(element => {
        if(typeof this.posicoeslivres[0] != "undefined"){
          let posi = this.posicoeslivres[0]
          this.posicoesComponente[posi - 1] = "Posição "+posi+": " +element.rgCaixa;
          this.posicoeslivres.splice(0, 1);
          let newAlc = {"posicao": posi, "rgRecipiente": element.rgCaixa}
          console.log(newAlc)
          this.novasAlocacoes.push(newAlc);
          incluidos.push(element)
        }else{
          this.openSnackBarError("Posição não encontrada para caixa: " + element.rgCaixa);
        }
    });

    incluidos.forEach(inc => {
      let posi = this.caixasDisponiveis.indexOf(inc);
      this.caixasDisponiveis.splice(posi, 1)
    });


  }
}



// WEBPACK FOOTER //
// /app/src/app/alocar-recipiente-dialog/alocar-recipiente-dialog.component.ts